export const NepaliGender = {
  male: 'पुरुष',
  female: 'महिला',
  other: 'यौनिक तथा लैङ्गिक अल्पसंख्यक'
};

export const EnglishGender = { male: 'Male', female: 'Female', other: 'Other' };
